
export const currencyFormat = (value: any) => {
  if (value || value === 0)
    return `R$ ${parseFloat(value).toFixed(2)}`.replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
  return value;
};

export const currencyFormatReal = (valor: string) => {
  var tmp = valor + '';
  tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
  if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

  return tmp;
};

export const currencyParser = (value: any) => {
  const n = (Number(`${value}`.replace(/[^0-9]+/g, '')) / 100).toFixed(2);
  if (parseFloat(n) > 0) return n;
  return '';
};

export const numberFormat = (value: any) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const numberParser = (value: any) => {
  const n = Number(`${value}`.replace(/[^0-9]+/g, ''));
  if (n > 0) return n;
  return '';
};

export const formatReal = (valor: string) => {
  let tmp = valor + '';
  tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
  tmp = tmp.replace('.,', ',');
  if (tmp.length > 6) {
    tmp = tmp.replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
  }
  return tmp;
};

export const FormatFormatter = (valor: number) => {
  let value = valor.toLocaleString('pt-br', { minimumFractionDigits: 2 });
  return value;
};

export const FormatParser = (valor: number) => {
  let value = parseFloat(valor.replace(/\./g, '').replace(',', '')) / 100;
  return value.toFixed(2);
};

export const formatRealFromBackend = (valor: string) => {
  let value = valor.replace(/\D/g, '');
  return `${value.slice(0, -2)}.${value.slice(-2)}`;
};

export const formatRealNovo = (int: any) => {
  var tmp = int + '';
  tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
  if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

  return tmp;
};

export const getMoney = (str: any) => {
  return parseInt(str.replace(/[\D]+/g, ''));
};

export const thousandSeparator = x => {
  if (x === undefined) return '0,00';
  let values = x.toString().split('.');
  let integers = values[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  if (values[0] === '') return '0,00';
  if (values[1] == undefined) return integers + ',00';
  if (values[1].lenght === 1) return integers + (values[1] ? ',' + values[1] : '0');
  return integers + (values[1] ? ',' + values[1] : '');
};

export const int2roman = (original: number): string => {
  if (original < 1 || original > 3999) {
    throw new Error('Error: Input integer limited to 1 through 3,999');
  }

  const numerals = [
    ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'], // 1-9
    ['X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'], // 10-90
    ['C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'], // 100-900
    ['M', 'MM', 'MMM'], // 1000-3000
  ];

  // Could expand to support fractions, simply rounding for now
  const digits = Math.round(original).toString().split('');
  let position = digits.length - 1;

  return digits.reduce((roman, digit) => {
    if (digit !== '0') {
      roman += numerals[position][parseInt(digit) - 1];
    }

    position -= 1;

    return roman;
  }, '');
};


export const testValores = (val: any) => {

  try {
    let str = "";

    str += " | 1 - " + currencyFormat(val);
    str += " | 2 - " + currencyFormatReal(val);
    str += " | 3 - " + currencyParser(val);
    str += " | 4 - " + numberFormat(val);
    str += " | 5 - " + numberParser(val);
    str += " | 6 - " + formatReal(val);
    str += " | 7 - " + FormatFormatter(val);
    str += " | 8 - " + FormatParser(val);
    str += " | 9 - " + formatRealFromBackend(val);
    str += " | 10 - " + formatRealNovo(val);
    str += " | 11 - " + getMoney(val);
    str += " | 12 - " + thousandSeparator(val);
    str += " | 13 - " + int2roman(val);

    return str;
  } catch {
    return "Err";
  }
};
